<style scoped lang="less">
.mask-wrapper{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:rgba(0,0,0,0.6);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .15s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>

<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="mask-wrapper"
      :style="{'z-index': zIndex}"
      @click="close"
    >
    </div>
  </transition>
</template>

<script>
import controlScroll from '@/mixin/controlScroll'
export default {
  mixins: [controlScroll],
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    zIndex: {
      type: Number,
      default: 99
    }
  },
  data() {
    return {
    }
  },
  watch: {
    visible :{
      handler: function (v) {
        if (v) {
          this.preventScroll()
        } else {
          this.allowScroll()
        }
      },
      immediate: true
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
